const serviceURL = 'https://migrupo.cc/view/service/';

function createBody(serviceTitle, serviceId) {
  return {
    tts: false,
    content: `\`${serviceTitle}\` service has been updated`,
    embeds: [
      {
        description: `[View Service](${serviceURL}${serviceId})`,
        color: 0x2d76e4,
      },
    ],
  };
}

export default function sendDiscordMessage(currentState, service, updatedService) {
  const teamId = currentState.currentService[0].team._id;
  const { songsIds: originalServiceSongIds } = service;
  const { songsIds: updatedServiceSongIds } = updatedService;

  let newChanges = false;

  if (originalServiceSongIds.length === updatedServiceSongIds.length) {
    originalServiceSongIds.forEach((originalSongId, index) => {
      if (originalSongId !== updatedServiceSongIds[index] && updatedServiceSongIds !== 'undefined') {
        newChanges = true;
      }
    });
  } else {
    newChanges = true;
  }

  try {
    if (newChanges) {
      if (teamId === process.env.REACT_APP_VINO_NUEVO_TEAM_ID.toString()) {
        const serviceTitle = currentState.currentServiceTitle;
        const serviceId = currentState.editServiceId;

        const body = createBody(serviceTitle, serviceId);

        fetch(process.env.REACT_APP_DISCORD_VINO_NUEVO_ID.toString(), {
          method: 'POST',
          body: JSON.stringify(body),
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          },
        });
      }
    }
  } catch (error) {}
}
